import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecentSearch, SearchTypes } from '../../../../models/global-search.model';
import { GetValueFromListPipe } from '../../../../pipes/get-value-from-list.pipe';

@Component({
  selector: 'app-recent-searches',
  standalone: true,
  imports: [CommonModule, GetValueFromListPipe],
  templateUrl: './recent-searches.component.html',
  styleUrl: './recent-searches.component.scss',
})
export class RecentSearchesComponent {
  @Input() searches: RecentSearch[] = [];

  @Output() select = new EventEmitter<RecentSearch>();
  @Output() remove = new EventEmitter<RecentSearch>();
  @Output() clearAll = new EventEmitter<void>();

  readonly searchTypeLabels = [
    { label: 'All', value: SearchTypes.all },
    { label: 'Datasets', value: SearchTypes.dataset },
    { label: 'Models', value: SearchTypes.model },
    { label: 'AI Tryouts', value: SearchTypes.tryout },
    { label: 'Use Cases', value: SearchTypes.usecase },
    { label: 'Toolkits', value: SearchTypes.toolkit },
    { label: 'Articles', value: SearchTypes.article },
    { label: 'Organizations', value: SearchTypes.organization },
    { label: 'Users', value: SearchTypes.user },
  ];

  onRemove(search: RecentSearch, event: MouseEvent) {
    event.stopPropagation();
    this.remove.emit(search);
  }
}
